// https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser

// @ts-ignore
export const isFirefox = typeof InstallTrigger !== "undefined";

export const isSafari =
  // @ts-ignore
  /constructor/i.test(window.HTMLElement) ||
  (function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
  })(
    // @ts-ignore
    !window["safari"] ||
      // @ts-ignore
      (typeof safari !== "undefined" && safari.pushNotification)
  );

// @ts-ignore Internet Explorer 6-11
export const isIE = /*@cc_on!@*/ !!document.documentMode;

// @ts-ignore Edge 20+
export const isEdge = !isIE && !!window.StyleMedia;

export const isChrome =
  // @ts-ignore
  !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

// @ts-ignore Edge (based on chromium) detection
export const isEdgeChromium = isChrome && navigator.userAgent.includes("Edg");
